// bi abt扩展相关

/**
 * 跳转分流实验 abt 信息
 * @returns
 */
export function getJumpPageABTestInfo() {
  let abtInfo = { fabtgroup: '', fabtlabel: '' };
  const abtSessionInfo = window.sessionStorage.getItem('index_jump_abt_info');
  if (abtSessionInfo) {
    abtInfo = JSON.parse(abtSessionInfo);
  }
  return {
    findexJumpabtgroup: abtInfo.fabtgroup,
    findexJumpabtlabel: abtInfo.fabtlabel,
  };
}
